import sensors from 'sa-sdk-javascript';
import store from '@/store';
import { SA_HOST } from '@/config/host';
import { isAndroid, formatTime } from '@hll/driver-js-utils';
import { GlobalUtil } from '@xl/js-utils';

// 由于隐私合规的要求，神策初始化时不应该去调用 APP 获取定位
// 最初在司机任务中的埋点要求有定位信息，以此为默认值
const positionStr = '0,0';

function install(Vue) {
  sensors.init({
    server_url: SA_HOST,
    // 单页面配置，默认开启，若页面中有锚点设计，需要将该配置删除，否则触发锚点会多触发 $pageview 事件
    is_track_single_page: true,
    use_client_time: true,
    send_type: 'beacon',
    heatmap: {
      // 是否开启点击图，default 表示开启，自动采集 $WebClick 事件，可以设置 'not_collect' 表示关闭。
      clickmap: 'not_collect',
      // 是否开启触达注意力图，not_collect 表示关闭，不会自动采集 $WebStay 事件，可以设置 'default' 表示开启。
      scroll_notice_map: 'not_collect',
    },
    // 是否控制台打印日志
    show_log: true,
  });

  Vue.prototype.$sa = sensors;
  Vue.prototype.$track = sensors.track;

  sensors.registerPage({
    trigger_time: formatTime(new Date(), 'YYYY-MM-DD HH:mm'),
    trigger_coordinates: positionStr,
    platform_type: isAndroid() ? 'Android' : 'IOS',
    driver_id: (store.state.app.urlParams || {}).driver_id || '',
    ...GlobalUtil.globalSensorProp(),
  });
  sensors.quick('autoTrack');
}

export default function(Vue) {
  install(Vue);
}

export {
  sensors,
};
